import React, { useState } from "react";
import MainTable from "./MainTable";
import Gainers from "./Gainers";
import Losers from "./Losers";
import Trending from "./Trending";
import Banner from "./Banner";
import UserCallback from "./UserCallback";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";

const tabsArray = [
  { id: 1, title: "Banner", value: "banner" },
  { id: 2, title: "Main Table", value: "main-table" },
  { id: 3, title: "Callback", value: "callback" },
];

const HomeScreenContent = () => {
  const [activeTab, setActiveTab] = useState("banner");

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <DashboardIcon sx={{ color: "#fff", fontSize: 32 }} />
        <Box>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
            Home Screen Content
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
            Manage banners, main table, and callbacks
          </Typography>
        </Box>
      </Box>

      {/* Tabs Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
          sx={{
            background: "#04343a",
            minHeight: 46,
            "& .MuiTab-root": {
              color: "rgba(255,255,255,0.6)",
              fontWeight: 600,
              fontSize: "13px",
              minHeight: 46,
              textTransform: "none",
              px: 3,
            },
            "& .Mui-selected": {
              color: "#fff !important",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1db954",
              height: 3,
            },
          }}
        >
          {tabsArray.map((tab) => (
            <Tab key={tab.id} label={tab.title} value={tab.value} />
          ))}
        </Tabs>

        <Box sx={{ p: 0 }}>
          {activeTab === "banner" && <Banner />}
          {activeTab === "main-table" && <MainTable />}
          {activeTab === "callback" && <UserCallback />}
          {activeTab === "gainers" && <Gainers />}
          {activeTab === "losers" && <Losers />}
          {activeTab === "trending" && <Trending />}
        </Box>
      </Box>
    </Box>
  );
};

export default HomeScreenContent;
